/**
 * Custom Tooltip Component
 * Handles rich tooltip content with links and buttons
 */

(function ($) {
    'use strict';

    class CustomTooltip {
        constructor() {
            this.init();
        }

        init() {
            this.bindEvents();
        }

        bindEvents() {
            const self = this;

            // Toggle tooltip on trigger click (supports both data-attribute and ID-based triggers)
            $(document).on('click', '.custom-tooltip-trigger, [id$="ToolTip"]', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const $trigger = $(this);
                let $tooltip;

                // Check if using data-tooltip-target attribute
                if ($trigger.data('tooltip-target')) {
                    const tooltipId = $trigger.data('tooltip-target');
                    $tooltip = $('#' + tooltipId);
                }
                // Otherwise, look for matching tooltip based on ID (e.g., annexToolTip -> annex-tooltip)
                else if ($trigger.attr('id')) {
                    const triggerId = $trigger.attr('id');
                    // Convert camelCase to kebab-case (e.g., annexToolTip -> annex-tooltip)
                    const tooltipId = triggerId.replace(/ToolTip$/, '-tooltip')
                        .replace(/([a-z])([A-Z])/g, '$1-$2')
                        .toLowerCase();
                    $tooltip = $('#' + tooltipId);
                }

                if (!$tooltip || !$tooltip.length) {
                    return;
                }

                // Close all other tooltips
                $('.custom-tooltip').not($tooltip).removeClass('show');

                // Toggle this tooltip
                $tooltip.toggleClass('show');

                if ($tooltip.hasClass('show')) {
                    // Store the trigger reference on the tooltip
                    $tooltip.data('trigger', $trigger);
                    self.positionTooltip($tooltip, $trigger);
                }
            });

            // Close tooltip when clicking outside
            $(document).on('click', function (e) {
                if (!$(e.target).closest('.custom-tooltip-trigger, [id$="ToolTip"], .custom-tooltip').length) {
                    $('.custom-tooltip').removeClass('show');
                }
            });

            // Close tooltip on ESC key
            $(document).on('keydown', function (e) {
                if (e.key === 'Escape' || e.keyCode === 27) {
                    $('.custom-tooltip').removeClass('show');
                }
            });

            // Reposition on window resize
            let resizeTimer;
            $(window).on('resize', function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                    $('.custom-tooltip.show').each(function () {
                        const $tooltip = $(this);
                        // Try to get the stored trigger reference first
                        let $trigger = $tooltip.data('trigger');
                        
                        // Fallback to lookup if trigger not stored
                        if (!$trigger || !$trigger.length) {
                            const tooltipId = $tooltip.attr('id');
                            $trigger = $('[data-tooltip-target="' + tooltipId + '"]');

                            // If no trigger found with data attribute, try ID-based lookup
                            if (!$trigger.length) {
                                // Convert tooltip ID back to trigger ID (e.g., annex-tooltip -> annexToolTip)
                                const triggerId = tooltipId.replace(/-tooltip$/, 'ToolTip')
                                    .replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
                                $trigger = $('#' + triggerId);
                            }
                        }

                        if ($trigger && $trigger.length) {
                            self.positionTooltip($tooltip, $trigger);
                        }
                    });
                }, 100);
            });

            // Reposition on scroll - use requestAnimationFrame for smoother updates
            let scrolling = false;
            $(window).on('scroll', function () {
                if (!scrolling) {
                    scrolling = true;
                    window.requestAnimationFrame(function() {
                        $('.custom-tooltip.show').each(function () {
                            const $tooltip = $(this);
                            // Try to get the stored trigger reference first
                            let $trigger = $tooltip.data('trigger');
                            
                            // Fallback to lookup if trigger not stored
                            if (!$trigger || !$trigger.length) {
                                const tooltipId = $tooltip.attr('id');
                                $trigger = $('[data-tooltip-target="' + tooltipId + '"]');

                                // If no trigger found with data attribute, try ID-based lookup
                                if (!$trigger.length) {
                                    // Convert tooltip ID back to trigger ID (e.g., annex-tooltip -> annexToolTip)
                                    const triggerId = tooltipId.replace(/-tooltip$/, 'ToolTip')
                                        .replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
                                    $trigger = $('#' + triggerId);
                                }
                            }

                            if ($trigger && $trigger.length) {
                                self.positionTooltip($tooltip, $trigger);
                            }
                        });
                        scrolling = false;
                    });
                }
            });
        }

        positionTooltip($tooltip, $trigger) {
            // Ensure the trigger element still exists in the DOM
            if (!$trigger || !$trigger.length || !$trigger.is(':visible')) {
                return;
            }

            const triggerOffset = $trigger.offset();
            const triggerHeight = $trigger.outerHeight();
            const triggerWidth = $trigger.outerWidth();
            const tooltipWidth = $tooltip.outerWidth();
            const tooltipHeight = $tooltip.outerHeight();
            const windowWidth = $(window).width();
            const windowHeight = $(window).height();
            const scrollTop = $(window).scrollTop();

            // Calculate top position (below the trigger with some spacing)
            let top = triggerOffset.top + triggerHeight + 8;

            // Calculate left position (try to center under trigger, but adjust if overflow)
            let left = triggerOffset.left - (tooltipWidth / 2) + (triggerWidth / 2);

            // Ensure tooltip doesn't go off screen on the right
            if (left + tooltipWidth > windowWidth - 20) {
                left = windowWidth - tooltipWidth - 20;
            }

            // Ensure tooltip doesn't go off screen on the left
            if (left < 20) {
                left = 20;
            }

            // Check if tooltip would be cut off at the bottom of the viewport
            // If so, position it above the trigger instead
            if (top + tooltipHeight > scrollTop + windowHeight - 20) {
                top = triggerOffset.top - tooltipHeight - 8;
                
                // If it's also cut off at the top, just position it below anyway
                if (top < scrollTop + 20) {
                    top = triggerOffset.top + triggerHeight + 8;
                }
            }

            // Apply position using transform for better performance
            $tooltip.css({
                top: top + 'px',
                left: left + 'px',
                position: 'absolute'
            });
        }
    }

    // Initialize on document ready
    $(document).ready(function () {
        new CustomTooltip();
    });

})(jQuery);

/**
 * Example function to show facilities on map
 * This can be customized based on your map implementation
 */
function showAnnexOnMap() {
    // Close the tooltip first
    $('.custom-tooltip').removeClass('show');
    
    // Scroll to map section if it exists
    const $map = $('#facility-map, .facility-map, [id*="map"]').first();

    if ($map.length) {
        $('html, body').animate({
            scrollTop: $map.offset().top - 100
        }, 500);
    }
}

